export const PERSONAL_DETAILS_STEP = 'app/ProgressBar/PERSONAL_DETAILS_STEP';
export const PAYMENT_DETAILS_STEP = 'app/ProgressBar/PAYMENT_DETAILS_STEP';


export const CONFIDENTIALITY_AGREEMENT_STEP = 'app/ProgressBar/CONFIDENTIALITY_AGREEMENT_STEP';
export const CONFLICT_OF_INTEREST_STEP = 'app/ProgressBar/CONFLICT_OF_INTEREST_STEP';
export const REVIEW_PROPOSAL_STEP = 'app/ProgressBar/REVIEW_PROPOSAL_STEP';
export const REVIEW_STEP_DONE = 'app/ProgressBar/REVIEW_STEP_DONE';